/* global axios */
import ApiClient from '../ApiClient';

// Viewer's UTC offset in hours, matching the reports API convention so the
// backend can anchor calendar ranges to the viewer's day.
const getTimezoneOffset = () => -new Date().getTimezoneOffset() / 60;

class CaptainAssistant extends ApiClient {
  constructor() {
    super('captain/assistants', { accountScoped: true });
  }

  get({ page = 1, searchKey } = {}) {
    return axios.get(this.url, {
      params: {
        page,
        searchKey,
      },
    });
  }

  playground({
    assistantId,
    messageContent,
    messageHistory,
    quotedProductId,
    imageDataUrl,
    audioDataUrl,
  }) {
    return axios.post(
      `${this.url}/${assistantId}/playground`,
      {
        message_content: messageContent,
        message_history: messageHistory,
        quoted_product_id: quotedProductId || undefined,
        image_data_url: imageDataUrl || undefined,
        audio_data_url: audioDataUrl || undefined,
      },
      { timeout: 90000 }
    );
  }

  listSalesPacks(assistantId) {
    return axios.get(`${this.url}/${assistantId}/sales_packs`);
  }

  previewSalesPack({ assistantId, packKey }) {
    return axios.get(`${this.url}/${assistantId}/sales_packs/${packKey}`);
  }

  applySalesPack({ assistantId, packKey }) {
    return axios.post(
      `${this.url}/${assistantId}/sales_packs/${packKey}/apply`,
      {
        confirm: true,
      }
    );
  }

  getOrders({ assistantId, page = 1 } = {}) {
    return axios.get(`${this.url}/${assistantId}/orders`, {
      params: { page },
    });
  }

  getStats({ assistantId, range }) {
    return axios.get(`${this.url}/${assistantId}/stats`, {
      params: { range, timezone_offset: getTimezoneOffset() },
    });
  }

  getSummary({ assistantId, range }) {
    return axios.get(`${this.url}/${assistantId}/summary`, {
      params: { range, timezone_offset: getTimezoneOffset() },
    });
  }

  getDrilldown({ assistantId, metric, range, page, signal }) {
    const requestConfig = {
      params: {
        metric,
        range,
        timezone_offset: getTimezoneOffset(),
        page,
      },
    };
    if (signal) requestConfig.signal = signal;

    return axios.get(`${this.url}/${assistantId}/drilldown`, requestConfig);
  }
}

export default new CaptainAssistant();
